import { render, staticRenderFns } from "./grid-col-span-editor.vue?vue&type=template&id=163e0823&scoped=true&"
import script from "./grid-col-span-editor.vue?vue&type=script&lang=js&"
export * from "./grid-col-span-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163e0823",
  null
  
)

export default component.exports